$(function() {
    'use strict';
    
    $('#form-login').validate({
        messages: {
            '_username': {
                required: "Privalote įvesti savo el. pašto adresą"
            },
            '_password': {
                required: "Privalote įvesti savo slaptažodį"
            }
        }
    });
});
